// #47: Datenart-Normalisierung + Tippfehler-Aehnlichkeit. Rein (keine IO), damit Web und Tests
// dieselbe Regel teilen. Normalisierung MUSS mit der SQL-Seite uebereinstimmen: lower(btrim(x)).
export function normalizeKind(s: string): string {
  return s.trim().toLowerCase();
}

export function levenshtein(a: string, b: string): number {
  const m = a.length;
  const n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  let prev: number[] = Array.from({ length: n + 1 }, (_, i) => i);
  let curr: number[] = Array.from({ length: n + 1 }, () => 0);
  for (let i = 1; i <= m; i++) {
    curr[0] = i;
    for (let j = 1; j <= n; j++) {
      const cost = a[i - 1] === b[j - 1] ? 0 : 1;
      curr[j] = Math.min(prev[j]! + 1, curr[j - 1]! + 1, prev[j - 1]! + cost);
    }
    [prev, curr] = [curr, prev];
  }
  return prev[n]!;
}

// true nur fuer echte Naehe (Distanz 1..maxDistance) — exakte normalisierte Gleichheit ist
// dieselbe Art, kein Aehnlichkeitshinweis (der Aufrufer waehlt sie dann direkt aus).
export function isSimilarKind(typed: string, existing: string, maxDistance = 2): boolean {
  const a = normalizeKind(typed);
  const b = normalizeKind(existing);
  if (a === b) return false;
  if (a.length === 0) return false;
  return levenshtein(a, b) <= maxDistance;
}

// #125 (Q5): Vorschlag für „Neuimport von" — robust gegen `_v3`, „(2)" und Trenner-Wechsel, weil
// ETO-Lieferungen nach der Nachbereinigung als `…_v3.xlsx` zurückkommen.
// #152: Endsilben werden wiederholt abgeschnitten (`_v2_edited`, `Kopie (2)_v3`), weil Kunden
// mehrere davon stapeln. Wortsilben brauchen einen Trenner davor, sonst würde „Credited" zu „Cr".
// #152 (Final-Review F7): dasselbe für die Version — ohne Trenner wäre „Rev3" der Stamm „Re" und
// damit dieselbe Datei wie „Re_v2". Nur der Kopie-Zähler „(N)" ist durch die Klammern eindeutig.
const FILE_NAME_TAIL = /(?:[\s_-]*\(\d+\)|[\s_-]+v\d+|[\s_-]+(?:edited|bearbeitet|kopie|copy))$/;

export function normalizeFileName(name: string): string {
  let stem = name.toLowerCase().replace(/\.xlsx?$/, '');
  for (let prev = ''; prev !== stem; ) {
    prev = stem;
    stem = stem.replace(FILE_NAME_TAIL, '');
  }
  return stem.replace(/[\s_-]+/g, ' ').trim();
}

// #152: Gleicher Dateistamm = dieselbe Lieferung in anderer Version. Kein Ähnlichkeitsmaß: die
// ETO-Dateien unterscheiden sich oft nur im ersten Wort („QM Z_Other Tcodes" vs. „PLM Z_Other
// Tcodes") und wären sonst zu 90 % „ähnlich". Ein leerer Stamm zählt nie als gleich.
export function isSameFileStem(a: string, b: string): boolean {
  const x = normalizeFileName(a);
  return x !== '' && x === normalizeFileName(b);
}

export function fileNameSimilarity(a: string, b: string): number {
  const x = normalizeFileName(a);
  const y = normalizeFileName(b);
  const maxLen = Math.max(x.length, y.length, 1);
  return 1 - levenshtein(x, y) / maxLen;
}
